import { combineReducers } from "redux";
import college_register from "../features/admin/college_register/register/Slice";

const collegeRegistration = combineReducers({
  college_register: college_register,
});

export default collegeRegistration;
